import useSeo from "@/hooks/useSeo";
import JsonLd from "@/components/feature/JsonLd";
import HeroSection from "@/pages/home/components/HeroSection";
import ChannelSection from "@/pages/home/components/ChannelSection";
import LatestSection from "@/pages/home/components/LatestSection";
import PrincipleSection from "@/pages/home/components/PrincipleSection";
import { latestArticles } from "@/mocks/articles";
import { site } from "@/mocks/site";

export default function Home() {
  useSeo({
    title: "深瞳档案 | 深扒幕后内幕 隐秘事件与暗黑真相整理",
    description:
      "深瞳档案专注幕后内幕与隐秘事件深度整理，栏目覆盖行业内幕、商业暗流、都市奇谈、网络迷雾与历史暗影，用编辑视角深扒黑幕、汇总内幕合集、还原事件背后的深层逻辑。",
    keywords: "黑暗爆料,内幕揭秘,幕后真相,深度调查,隐秘事件,内幕合集",
    path: "/",
    type: "website",
  });

  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: site.name,
      url: "https://www.shentongdangan.cn/",
      inLanguage: "zh-CN",
      description: site.intro,
      potentialAction: {
        "@type": "SearchAction",
        target: "https://www.shentongdangan.cn/channels?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: site.name,
      url: "https://www.shentongdangan.cn/",
      email: site.email,
      description: site.intro,
      slogan: site.slogan,
    },
  ];

  return (
    <>
      <JsonLd data={schema} />
      <HeroSection />
      <ChannelSection />
      <LatestSection
        title="最新档案"
        subtitle="按收录时间排序，最近的整理都放在这里。"
        list={latestArticles(6)}
        morePath="/channels"
      />
      <PrincipleSection />
    </>
  );
}